import React from 'react';
import { Box } from '@mui/material';

type BcallLogoProps = {
  size?: number;
};

export const BcallLogo: React.FC<BcallLogoProps> = ({ size = 40 }) => {
  return (
    <Box
      aria-label="Bcall logo"
      sx={{
        width: size,
        height: size,
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #2979ff 0%, #1565c0 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 800,
        fontSize: `${Math.max(12, Math.round(size * 0.35))}px`,
        letterSpacing: '0.5px',
        userSelect: 'none'
      }}
    >
      b
    </Box>
  );
};
